const STYLES = {
  tutorial: {
    fontColor: '#8D8D8D',
    circle: {
      text: '#8D8D8D',
      border: '#8D8D8D',
      background: '#FFF'
    },
    circleActive: {
      text: '#FFF',
      border: '#62BB46',
      background: '#62BB46'
    },
    circleComplete: {
      text: '#FFF',
      border: '#8D8D8D',
      background: '#8D8D8D'
    }
  }
}

export default STYLES
